var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2 inline-flex"},[_c('router-link',{attrs:{"to":`/member/${_vm.params.value}`}},[_c('vs-button',{attrs:{"size":"small","color":"success","type":"border","icon":"description"}},[_vm._v("\n      ข้อมูลยูสเซอร์\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }